import styled, { css } from 'styled-components';

export const ScrollSidebar = styled.div`
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
`;

export const MainSidebar = styled.div`
  display: flex;
  flex-direction: column;
  padding: 0px;
  border-radius: 10px;
  box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
  & > * + * {
    margin-top: 2px;
  }
`;

export const OptionGroup = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  width: 100%;
  align-items: center;
  justify-content: center;
  margin-bottom: 5px;
  & button:first-child {
    border-radius: 8px 0 0 8px;
  }
  & button:last-child {
    border-radius: 0 8px 8px 0;
  }
`;

export const Option = styled.button`
  background-color: ${({ theme }) => theme.containerOdd};
  color: ${({ theme }) => theme.primary};
  padding: 5px;
  border: none;
  box-sizing: border-box;
  display: flex;
  align-items: center;
  justify-content: center;
  min-width: 130px;
  font-weight: bold;
  font-size: 16px;
  height: 38px;
  cursor: pointer;
  & svg {
    height: 22px;
    width: 22px;
    margin-right: 5px;
  }
  ${({ theme, active }) => (active ? css`
    background-color: ${theme.primary};
    color: ${theme.white};
    & svg {
      fill: ${theme.white};
    }
  ` : css`
    &:hover {
      background-color: ${theme.selectHover};
    }
  `)}
`;
